import { LanguageOptions } from '@common/enums';

export function formatNumber(
    numberToFormat: number,
    language: LanguageOptions = LanguageOptions.nl,
    options?: Intl.NumberFormatOptions
) {
    return new Intl.NumberFormat(language, options).format(numberToFormat);
}
